import styled from 'styled-components';
import ThankYouSvg from '../../assets/hotels/thankyouSuccess.svg';

const ThankYouSuccessImg = styled(ThankYouSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '29.6rem'};
  height: ${props => props.height || '19.9rem'};
  margin: ${props => props.margin};
`;

export default ThankYouSuccessImg;
